import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  Stack,
  useTheme,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const schemes = [
  {
    title: 'प्रधानमंत्री आवास योजना (PMAY)',
    description: 'Housing scheme for rural residents providing financial assistance for building pucca houses.',
    image: '/pmay2.jpg',
    benefits: ['Financial assistance up to ₹1.20 lakh', 'Additional funding through convergence', 'Technical support'],
    applyLink: 'https://pmaymis.gov.in/'
  },
  {
    title: 'महात्मा गांधी रोजगार हमी योजना (MNREGA)',
    description: 'Employment guarantee scheme providing 100 days of wage employment.',
    image: '/mg.png',
    benefits: ['Guaranteed employment', 'Equal wages for men and women', 'Unemployment allowance'],
    applyLink: 'https://nrega.nic.in/'
  },
  {
    title: 'स्वच्छ भारत मिशन',
    description: 'Clean India Mission focusing on sanitation and waste management.',
    image: '/swach_bharat.png',
    benefits: ['Toilet construction support', 'Waste management', 'Clean village incentives'],
    applyLink: 'https://swachhbharatmission.gov.in/'
  },
  {
    title: 'दीनदयाल उपाध्याय ग्रामीण कौशल्य योजना',
    description: 'Skill development program for rural youth.',
    image: '/DDUGKY.png',
    benefits: ['Free training', 'Placement assistance', 'Stipend during training'],
    applyLink: 'https://www.xn--i1bj3fqcyde.xn--11b7cb3a6a.xn--h2brj9c/spotlight/%E0%A4%A6%E0%A5%80%E0%A4%A8-%E0%A4%A6%E0%A4%AF%E0%A4%BE%E0%A4%B2-%E0%A4%89%E0%A4%AA%E0%A4%BE%E0%A4%A7%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%AF-%E0%A4%97%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%AE%E0%A5%80%E0%A4%A3-%E0%A4%95%E0%A5%8C%E0%A4%B6%E0%A4%B2%E0%A5%8D%E0%A4%AF-%E0%A4%AF%E0%A5%8B%E0%A4%9C%E0%A4%A8%E0%A4%BE'
  },
  {
    title: 'प्रधानमंत्री कृषि सिंचाई योजना',
    description: 'Irrigation scheme for farmers to improve water efficiency.',
    image: '/pmksy.png',
    benefits: ['Water conservation', 'Improved farming', 'Sustainable practices'],
    applyLink: 'https://pmksy.gov.in/'
  },
  {
    title: 'जन धन योजना',
    description: 'Financial inclusion program providing banking services.',
    image: '/pmjdy.jpg',
    benefits: ['Zero balance account', 'RuPay debit card', 'Insurance coverage'],
    applyLink: 'https://pmjdy.gov.in/'
  },
];

const Schemes = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ mb: 6, textAlign: 'center' }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Government Schemes
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            Explore various government schemes available for village development
          </Typography>
        </Box>

        {/* Schemes Grid */}
        <Grid container spacing={4}>
          {schemes.map((scheme, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  overflow: 'hidden',
                  boxShadow: 3,
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': { transform: 'scale(1.02)' }
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: '250px',  // Fixed height for consistency
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f5f5f5'
                  }}
                >
                  <CardMedia
                    component="img"
                    src={scheme.image}
                    alt={scheme.title}
                    sx={{
                      maxWidth: '90%',
                      maxHeight: '90%',
                      objectFit: 'contain' // Ensures full image is visible
                    }}
                  />
                </Box>
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h5" gutterBottom component="h2">
                    {scheme.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" paragraph>
                    {scheme.description}
                  </Typography>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Key Benefits:
                    </Typography>
                    <Stack spacing={1}>
                      {scheme.benefits.map((benefit, idx) => (
                        <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <ArrowForwardIcon color="primary" fontSize="small" />
                          <Typography variant="body2">
                            {benefit}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                </CardContent>
                <Box sx={{ p: 2, pt: 0, display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ backgroundColor: '#00106e', px: 4, py: 1 }}
                    onClick={() => window.open(scheme.applyLink, "_blank")}
                  >
                    Apply Now
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Schemes;
